export const letterRegex = new RegExp(/\p{L}/, "gu");
